import React from 'react';
import Icon from '../../../components/AppIcon';

const PathProgressBar = ({ percent }) => (
  <div className="h-1.5 bg-muted rounded-full overflow-hidden">
    <div className="h-full bg-accent rounded-full transition-all" style={{ width: `${percent}%` }} />
  </div>
);

const MyPathCard = ({ title, progress }) => (
  <div className="bg-white/60 backdrop-blur-xl border border-white/40 rounded-xl p-4">
    <div className="flex items-center justify-between mb-2 gap-2">
      <h4 className="text-sm font-semibold text-foreground truncate">{title}</h4>
      <span className="text-xs text-muted-foreground flex-shrink-0">{progress.completed}/{progress.total}</span>
    </div>
    <PathProgressBar percent={progress.percent} />
  </div>
);

const BrowsePathCard = ({ listing, onEnroll, enrolling }) => (
  <div className="bg-white/60 backdrop-blur-xl border border-white/40 rounded-xl p-4 flex flex-col gap-2">
    <div className="flex items-center gap-1.5">
      <Icon name="Route" size={14} className="text-accent" />
      <h4 className="text-sm font-semibold text-foreground truncate">{listing?.title}</h4>
    </div>
    {listing?.description && <p className="text-xs text-muted-foreground line-clamp-2">{listing.description}</p>}
    <p className="text-xs text-muted-foreground">{listing?.nodeCount || 0} courses</p>
    <button
      onClick={() => onEnroll(listing)}
      disabled={enrolling}
      className="mt-1 text-xs font-medium px-3 py-1.5 rounded-lg bg-accent text-white hover:bg-accent/90 transition-smooth disabled:opacity-60"
    >
      {enrolling ? 'Enrolling…' : 'Enroll in path'}
    </button>
  </div>
);

const LearningPathsSection = ({ myPaths, browsablePaths, onEnroll, enrollingPathId }) => {
  if (myPaths?.length === 0 && browsablePaths?.length === 0) return null;

  return (
    <div className="space-y-4">
      {myPaths?.length > 0 && (
        <div className="space-y-3">
          <h3 className="text-base sm:text-lg font-semibold text-foreground px-1">Your Learning Paths</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {myPaths.map((p) => (
              <MyPathCard key={p.pathId} title={p.title} progress={p.progress} />
            ))}
          </div>
        </div>
      )}

      {browsablePaths?.length > 0 && (
        <div className="space-y-3">
          <h3 className="text-base sm:text-lg font-semibold text-foreground px-1">Explore Learning Paths</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {browsablePaths.map((listing) => (
              <BrowsePathCard
                key={listing.pathId}
                listing={listing}
                onEnroll={onEnroll}
                enrolling={enrollingPathId === listing.pathId}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LearningPathsSection;